import React from "react";

import Row from "../../common/Row";
import Certificates from "./Certificates";
import Feedback from "./Feedback";
import ApFeedback from "./ApFeedback";
import Introduction from "./Introduction";
import ContactUs from "./ContactUs";
import Promises from "./Promises";
import Features from "./Features";
import Philosophy from "./Philosophy";

const Home = () => {
  return (
    <div>
      <div className="bg-emerald-500 h-50">
        <Row>
          <Introduction />
          <ContactUs />
        </Row>
      </div>
      <Philosophy />
      <Features />
      <Feedback />
      <ApFeedback />
      <Certificates />
      <div className="md:w-3/4 m-auto">
        <Promises />
      </div>
    </div>
  );
};

export default Home;
